import React from "react";
import Hero from "../components/Hero";
import How from "../components/How";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-gray-50">
      <main className="flex-grow">
        <Hero />
        <How />
      </main>
      <Footer />
    </div>
  );
}